import React, { useState, useEffect } from "react";
import { BsDownload } from "react-icons/bs";
import pdf from "../Resume_FE.pdf";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Resume = () => {
  const [numPages, setNumPages] = useState(null);
  const [wid, setwid] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setwid(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const scale = wid < 700 ? (wid > 475 ? 0.7 : 0.5) : 1;

  return (
    <div className="ResumePage">
      <Document
        file={pdf}
        className="resumeview"
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            scale={scale}
          />
        ))}
      </Document>

      <a
        href={pdf}
        target="_blank"
        rel="noopener noreferrer"
        download="NguyenDangTrung_FrontendDev_Resume"
      >
        <button className="downloadCV" type="button">
          <h3>
            <BsDownload />
            &nbsp; Download CV
          </h3>
        </button>
      </a>
    </div>
  );
};

export default Resume;
